/**
 * Framework access helpers (parity with V1).
 * Full access: userTypeId !== 4 (Member / subscribed)
 * Limited: userTypeId === 4 (Retail / non-subscriber)
 *
 * Dev preview (local QA only, does not change API/session):
 *   /dashboard-v2?preview=limited   → force limited shell
 *   /dashboard-v2?preview=full      → clear preview override
 */

const PREVIEW_LIMITED_KEY = 'dv2PreviewLimited';

export function isLimitedFrameworkAccess(session) {
    if (!session) return false;
    return Number(session.userTypeId) === 4;
}

export function readLimitedPreviewForced() {
    if (typeof window === 'undefined') return false;
    if (window.APP_CONFIG && window.APP_CONFIG.forceLimitedDashboard === true) {
        return true;
    }
    if (window.__DV2_PREVIEW_LIMITED__ === true) return true;
    try {
        if (window.sessionStorage?.getItem(PREVIEW_LIMITED_KEY) === '1') {
            return true;
        }
    } catch {
        /* ignore */
    }
    return false;
}

/** Apply ?preview=limited|full (or ?limited=1|0) and persist for the browser session. */
export function syncLimitedPreviewFromSearch(search = '') {
    if (typeof window === 'undefined') return;
    const params = new URLSearchParams(search);
    const enable =
        params.get('preview') === 'limited' ||
        params.get('limited') === '1' ||
        params.get('nonSubscriber') === '1';
    const disable =
        params.get('preview') === 'full' ||
        params.get('limited') === '0';

    try {
        if (enable) {
            window.sessionStorage.setItem(PREVIEW_LIMITED_KEY, '1');
            window.__DV2_PREVIEW_LIMITED__ = true;
        } else if (disable) {
            window.sessionStorage.removeItem(PREVIEW_LIMITED_KEY);
            window.__DV2_PREVIEW_LIMITED__ = false;
        }
    } catch {
        /* ignore */
    }
}

export function clearLimitedPreviewOverride() {
    if (typeof window === 'undefined') return;
    try {
        window.sessionStorage.removeItem(PREVIEW_LIMITED_KEY);
    } catch {
        /* ignore */
    }
    window.__DV2_PREVIEW_LIMITED__ = false;
}

export function resolveLimitedFrameworkAccess(session, search = '') {
    syncLimitedPreviewFromSearch(search);
    if (readLimitedPreviewForced()) return true;
    return isLimitedFrameworkAccess(session);
}

export function isLimitedPreviewActive(session, search = '') {
    syncLimitedPreviewFromSearch(search);
    return readLimitedPreviewForced() && !isLimitedFrameworkAccess(session);
}

export function getFrameworkUpgradeUrl(config) {
    if (!config) return '#';
    return (
        config.UPGRADE_URL ||
        config.UPDGRADEACCOUNTLINK ||
        config.enrollmentURL ||
        '#'
    );
}
